export default __webpack_public_path__ + "static/media/reversals.c247d2c8.svg";